export default __webpack_public_path__ + "assets/images/49a76f26aa078b44df88cec34a879e12.svg";